// src/components/CustomHidden.tsx

import Hidden from '@mui/material/Hidden'; // Replace with the correct import path for your version
import React from 'react';

// Explicitly cast Hidden to a Function Component
const CustomHidden = Hidden as React.FC<any>;

export default CustomHidden;
